module.exports = __webpack_public_path__ + "static/img/icon h pdfys.0a73e129.svg";